import logo from './logo.svg';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { NavBar } from "./components/NavBar";
import { Banner } from "./components/Banner";
import Skills from "./components/Skills";
import { Projects } from "./components/Experience";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import About from './components/About';

function App() {
  return (
    <div className="App">
      <NavBar />
      <Banner />
      <About />
      <Projects />
      <Skills />
      {/* <Contact /> */}
      <Footer />
    </div>
  );
}

export default App;
